<template>
  <v-container id="invocie-create" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <v-form id="form">
          <v-col>
            <v-card>
              <v-row class="px-5 py-2">
                <v-col cols="12" md="2">
                  <z-client-select
                    :label="$i18n.t('Client')"
                    class="purple-input"
                    withSelf
                    v-model="filter.client_id"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <z-entity-select
                    :label="$i18n.t('Client Entity')"
                    class="purple-input"
                    :corp="filter.client_id"
                    v-model="filter.clientEntity_id"
                  />
                </v-col>
                <!-- <v-col>
                  <z-vendor-select
                    :label="$i18n.t('Vendor')"
                    class="purple-input"
                    withSelf
                    v-model="filter.vendor_id"
                  />
                </v-col> -->
                <v-col cols="12" md="2">
                  <z-entity-select
                    :label="$i18n.t('Supplier Entity')"
                    class="purple-input"
                    corp="self"
                    v-model="filter.vendorEntity_id"
                  />
                </v-col>
                <!-- <v-col cols="12" md="2">
                  <v-select
                    :items="invoiceTypes"
                    clearable
                    :label="$i18n.t('Invoice Type')"
                    v-model="filter.invoiceType"
                    item-text="name"
                    item-value="value"
                  ></v-select>
                </v-col> -->

                <v-col cols="12" md="2">
                  <z-date-picker
                    :label="$i18n.t('From Date')"
                    class="purple-input"
                    v-model="filter.bookingFromDate"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <z-date-picker
                    :label="$i18n.t('Till Date')"
                    class="purple-input"
                    v-model="filter.bookingToDate"
                  />
                </v-col>

                <!-- <v-col cols="12" md="2">
                  <v-text-field
                    class="purple-input"
                    :label="$i18n.t('Cost Center')"
                    v-model="filter.costCenter"
                  />
                </v-col> -->

                <!-- <v-col cols="12" md="2">
                  <v-text-field
                    class="purple-input"
                    :label="$i18n.t('Passenger Name')"
                    v-model="filter.employeeName"
                  />
                </v-col> -->
                <v-col cols="12" md="2">
                  <v-text-field
                    :label="$i18n.t('LR. No')"
                    class="purple-input"
                    v-model="filter.cargos.lr.number"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    :label="$i18n.t('Trip/Cargo No')"
                    class="purple-input"
                    v-model="filter.tripNo"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    :label="$i18n.t('Duty Slip No')"
                    class="purple-input"
                    v-model="filter.dutySlipNo"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    :label="$i18n.t('Vehicle Reg No')"
                    class="purple-input"
                    v-model="filter.vehRegNo"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <z-city-select
                    :label="$i18n.t('PickUp City')"
                    v-model="filter.src.city"
                    :country="'India'"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <z-city-select
                    :label="$i18n.t('Drop City')"
                    v-model="filter.dstCity"
                    :country="'India'"
                  />
                </v-col>

                <!-- <v-col cols="12" md="2">
                  <z-payment-mode-select
                    clearable
                    v-model="filter.paymentMode"
                  />
                </v-col> -->
              </v-row>

              <v-row class="px-7 py-2">
                <v-btn-toggle
                  rounded
                  style="float: left; background: transparent"
                >
                  <v-btn
                    small
                    :color="!filter.proforma ? 'blue' : 'grey'"
                    @click="filter.proforma = false"
                  >
                    <h3 style="padding-right: 20px">
                      <div
                        style="width: 20px; height: 12px; float: left"
                        v-if="!filter.proforma"
                      ></div>
                      <v-icon v-if="!filter.proforma" color="white"
                        >mdi-check</v-icon
                      >Invoice
                    </h3>
                  </v-btn>
                  <v-btn
                    small
                    :color="filter.proforma ? 'blue' : 'grey'"
                    @click="filter.proforma = true"
                  >
                    <h3 style="padding-right: 20px">
                      <div
                        style="width: 20px; height: 12px; float: left"
                        v-if="filter.proforma"
                      ></div>
                      <v-icon v-if="filter.proforma" color="white"
                        >mdi-check</v-icon
                      >Proforma
                    </h3>
                  </v-btn>
                </v-btn-toggle>
              </v-row>

              <v-row v-show="!filter.proforma" class="px-5 py-2">
                <!-- <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="filter.showInvoiced"
                    :label="$i18n.t('Show Invoiced')"
                  ></v-checkbox>
                </v-col> -->
                <!-- <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="filter.completedID"
                    :label="$i18n.t('Completed')"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="filter.ranOfflineID"
                    :label="$i18n.t('Ran Offline')"
                  ></v-checkbox>
                </v-col> -->
                <!-- <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="filter.cancelledID"
                    :label="$i18n.t('Cancelled')"
                  ></v-checkbox>
                </v-col> -->
                <!-- <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="filter.verified"
                    :label="$i18n.t('Verified')"
                  ></v-checkbox>
                </v-col> -->
                <!-- <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="filter.includeTaxFree"
                    :label="$i18n.t('Include Cash Duty')"
                  ></v-checkbox>
                </v-col> -->
                <!-- <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="filter.holdInvoicing"
                    :label="$i18n.t('Invoicing OnHold')"
                  ></v-checkbox>
                </v-col> -->
                <!-- <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="filter.excludePayByCash"
                    :label="$i18n.t('Exclude Paid by Cash')"
                  ></v-checkbox>
                </v-col> -->
                <!-- <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="filter.ignoreCancelled"
                    :label="$i18n.t('Ignore Cancelled Trip')"
                  ></v-checkbox>
                </v-col> -->
              </v-row>

              <v-card-actions class="sticky-bottom">
                <v-spacer></v-spacer>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mr-0"
                      color="grey darken"
                      fab
                      text
                      small
                      @click="downloadMIS()"
                      style="margin-right: 10px !important"
                      v-on="on"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $i18n.t("Download") }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mr-0"
                      color="grey darken"
                      fab
                      text
                      small
                      @click="clear()"
                      style="margin-right: 10px !important"
                      v-on="on"
                    >
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $i18n.t("Clear Filter") }}</span>
                </v-tooltip>
                <v-btn
                  color="success"
                  class="mr-0"
                  fab
                  small
                  dark
                  @click="filterTrip()"
                  :loading="loading"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>

                <v-btn
                  color="secondary"
                  class="mr-0"
                  dark
                  text
                  @click="createInvoiceDialog('all')"
                  v-show="grid.rows.length > 0"
                >
                  {{
                    $i18n.t("Create for all ") +
                    grid.rows.length +
                    $i18n.t(" trip(s)")
                  }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-form>
      </v-col>
    </v-row>

    <base-material-card
      icon="mdi-map-marker-path"
      :title="$i18n.t('Trips')"
      class="px-5 py-3"
      v-if="grid.records"
    >
      <v-row>
        <v-col cols="8" lg="8" md="8">
          <z-grid-record :grid="grid" />

          <v-card
            class="py-0 my-2"
            elevation="1"
            color="blue lighten-5 d-none d-md-flex"
          >
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="12" xs="10" sm="10">
                  <v-row>
                    <v-col cols="12" md="3">{{ $i18n.t("Title") }}</v-col>
                    <v-col cols="12" md="9">{{ $i18n.t("Details") }}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" xs="2" sm="2" class="text-right pl-0">
                  {{ $i18n.t("Action") }}
                  <v-btn
                    @click="addAllSelected"
                    fab
                    text
                    small
                    color="success"
                    :label="$i18n.t('Select All')"
                  >
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card
            v-for="booking in grid.rows"
            :key="booking._id"
            class="py-0 my-2"
            elevation="1"
          >
            <BookingRow
              v-if="!booking.addedToSelected"
              :value="booking"
              @addToSelected="addToSelected"
            />
          </v-card>

          <v-container>
            <v-pagination
              v-model="grid.page"
              class="my-4"
              :length="grid.total"
              total-visible="10"
              @input="showPage"
            ></v-pagination>
          </v-container>
        </v-col>
        <v-col cols="4" lg="4" md="4">
          <v-card
            class="py-0 my-2"
            elevation="1"
            color="blue lighten-5 d-none d-md-flex"
          >
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="12" xs="10" sm="10">
                  <v-row>
                    <v-col cols="12" md="3">{{ $i18n.t("Title") }}</v-col>
                    <v-col cols="12" md="9">{{ $i18n.t("Details") }}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" xs="2" sm="2" class="text-center pl-0">
                  {{ $i18n.t("Action") }}
                </v-col>
              </v-row>
              <v-row>
                <v-btn
                  @click="createInvoiceDialog('selected')"
                  ng-show="selctedTrips.length > 0"
                  text
                  dark
                  class="mr-0"
                  color="secondary"
                >
                  {{ $i18n.t("Create for selcted ") }}
                  {{ selctedTrips.length }} {{ $i18n.t(" trip(s)") }}
                </v-btn>

                <v-btn
                  fab
                  text
                  small
                  class="mr-0"
                  color="error text-right"
                  @click="removeAllSelected"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card
            v-for="(booking, i) in selctedTrips"
            :key="booking._id + i"
            class="py-0 my-2"
            elevation="1"
          >
            <BookingRow
              :value="booking"
              @removeFromSelected="removeFromSelected"
              :remove="true"
            />
          </v-card>
        </v-col>
      </v-row>
    </base-material-card>
    <z-invoice-create
      :filters="finalFilters"
      :showDialog="showCreateInvoice"
      :createInvoiceType="createInvoiceType"
      :selctedTrips="selctedTrips"
      :routes="grid.rows"
      :appendParam="appendParam"
      @closeDialog="closeDialog"
    />
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import BookingRow from "@/views/invoice/BookingRow.vue";
import auth from "@/store/user/module/auth";

@Component({
  props: {
    appendParam: {
      default: null,
    },
    invoiceTab: {
      default: null,
    },
  },
  components: {
    BookingRow,
  },
})
export default class CreateInvoice extends Vue {
  grid = { page: 0, rows: [] };
  filter = {
    financialYear: "",
    bookingFromDate: "",
    bookingToDate: "",
    fromDate: "",
    toDate: "",
    invoiceNo: null,
    client_id: null,
    clientEntity_id: null,
    shippedToEntity_id: null,
    vendor_id: null,
    vendorEntity_id: null,
    bookingNo: null,
    invoiceType: 2,
    status: "",
    proforma: false,
    verified: true,
    includeTaxFree: false,
    excludePayByCash: true,
    cargos:{
      lr:{
        number:null
      }
    },
    src:{
      city:null,
    }
  };
  invoiceTypes = [
    {
      name: "Cargo",
      value: "1",
    },
    {
      name: "Trip",
      value: "2",
    },
  ];
  finalFilters = this.filter;
  showCreateInvoice = false;
  rows = 20;
  url_filter1 = "";
  selctedTrips = [];
  url1 = "/api/corp/trips/data?forInvoice=true&rows=" + this.rows;
  createInvoiceType = "all";
  webcontent = {};

  createInvoiceDialog(selected) {
    this.createInvoiceType = selected;
    this.finalFilters.vendor_id = this.webcontent.corp_id;
    this.showCreateInvoice = true;
  }

  closeDialog() {
    this.showCreateInvoice = false;
  }

  removeFromSelected(booking) {
    const index = this.grid.rows.findIndex((v) => v._id == booking._id);
    if (index != -1) {
      this.grid.rows[index].addedToSelected = false;
    }
    const index1 = this.selctedTrips.findIndex((v) => v._id == booking._id);
    this.selctedTrips.splice(index1, 1);
  }

  removeAllSelected() {
    for (let i = 0; i < this.grid.rows.length; i++) {
      if (this.grid.rows[i].addedToSelected) {
        const index = this.grid.rows.findIndex(
          (v) => v._id == this.grid.rows[i]._id
        );
        if (index != -1) {
          this.grid.rows[index].addedToSelected = false;
        }
        const index1 = this.selctedTrips.findIndex(
          (v) => v._id == this.grid.rows[i]._id
        );
        this.selctedTrips.splice(index1, 1);
      }
    }
  }

  async downloadMIS() {
    if (!this.validateReport()) {
      return;
    }
    this.finalFilters = this.filter;
    const url = await this.filterTripParam(
      "/api/trips/tripInvoiceData/download?_search=true",
      this.finalFilters
    );
    window.open(url, "_blank");
  }

  addToSelected(booking) {
    booking.addedToSelected = true;
    for (let i = 0; i < this.grid.rows.length; i++) {
      if (this.grid.rows[i]._id === booking._id)
        this.grid.rows[i].addToSelected = true;
    }
    this.selctedTrips.push(booking);
  }

  addAllSelected() {
    for (let i = 0; i < this.grid.rows.length; i++) {
      if (!this.grid.rows[i].addedToSelected) {
        this.selctedTrips.push(this.grid.rows[i]);
        this.grid.rows[i].addedToSelected = true;
      }
    }
  }

  clear() {
    this.filter = {
      financialYear: "",
      bookingFromDate: "",
      bookingToDate: "",
      fromDate: "",
      toDate: "",
      invoiceNo: null,
      client_id: '',
      clientEntity_id: null,
      shippedToEntity_id: null,
      vendor_id: null,
      vendorEntity_id: null,
      bookingNo: null,
      invoiceType: 2,
      status: "",
      proforma: false,
      cargos:{
      lr:{
        number:null
      }
    },
    src:{
      city:'',
    }
    };
  }

  validateReport() {
    if (!this.filter.client_id) {
      common.setError("Please select client");
      return false;
    }
    // if (!this.filter.vendor_id) {
    //   common.setError("Please select vendor");
    //   return false;
    // }

    if (!this.filter.invoiceType) {
      common.setError("Please Select invoice type.");
      return false;
    }
    return true;
  }

  postFatchMakeSelected(routes) {
    if (
      this.selctedTrips &&
      this.selctedTrips.length > 0 &&
      routes &&
      routes.length > 0
    ) {
      for (let i = 0; i < routes.length; i++) {
        for (let j = 0; j < this.selctedTrips.length; j++) {
          if (this.selctedTrips[j]._id === routes[i]._id) {
            routes[i].addedToSelected = true;
          } else {
            routes[i].addedToSelected = false;
          }
        }
      }
    }
    return routes;
  }

  showPage(page) {
    this.fetchTripData(this.url_filter1, page);
  }

  async fetchTripData(url1, page) {
    if (!url1) url1 = this.url1;
    common.setLoading(true);
    try {
      const data = await doGet(url1 + "&page=" + page);
      data.rows = this.postFatchMakeSelected(data.rows);
      this.grid = data;
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  async filterTripParam(url, finalFilters) {
    await auth.doPostLogin();
    url = this.appendParam(url, "client_id", finalFilters.client_id);
    url = this.appendParam(url, "vendor_id", auth.authContent.corp_id);
    // url = this.appendParam(url, "vendor", finalFilters.vendor_id);
    let status = "";
    if (finalFilters.completedID) {
      status = finalFilters.completedID;
    }
    if (finalFilters.ranOfflineID) {
      status = status + "," + finalFilters.ranOfflineID;
    }
    if (finalFilters.cancelledID) {
      status = status + "," + finalFilters.cancelledID;
    }
    // if (finalFilters.verified) {
    //   url = this.appendParam(url, "verified", true);
    // }
    // if (finalFilters.includeTaxFree) {
    //   url = this.appendParam(url, "includeTaxFree", true);
    // }
    // if (finalFilters.excludePayByCash) {
    //   url = this.appendParam(url, "excludePayByCash", true);
    // }
    // if (finalFilters.holdInvoicing) {
    //   url = this.appendParam(url, "holdInvoicing", true);
    // }
    if (finalFilters.ignoreCancelled) {
      url = this.appendParam(url, "ignoreCancelled", true);
    }
    if (finalFilters.proforma) {
      url = this.appendParam(url, "proforma", finalFilters.proforma);
    }

    url = this.appendParam(url, "pickDateFrom", finalFilters.bookingFromDate);
    url = this.appendParam(url, "cargos.lr.number", finalFilters.cargos.lr.number);
    url = this.appendParam(url, "pickDateTill", finalFilters.bookingToDate);
    // url = this.appendParam(url, "invoiceType", finalFilters.invoiceType);
    // url = this.appendParam(url, "employeeName", finalFilters.employeeName);
    // url = this.appendParam(url, "costCenter", finalFilters.costCenter);
    // url = this.appendParam(url, "bookingNo", finalFilters.bookingNo);
    // url = this.appendParam(url, "showInvoiced", finalFilters.showInvoiced);
    url = this.appendParam(url, "fromDate", finalFilters.bookingFromDate);
    url = this.appendParam(url, "toDate", finalFilters.bookingToDate);
    url = this.appendParam(url, "invoiceType", finalFilters.invoiceType);
    url = this.appendParam(url, "employeeName", finalFilters.employeeName);
    // url = this.appendParam(url, "costCenter", finalFilters.costCenter);
    url = this.appendParam(url, "bookingNo", finalFilters.bookingNo);
    url = this.appendParam(url, "showInvoiced", finalFilters.showInvoiced);
    url = this.appendParam(url, "dutySlipNo", finalFilters.dutySlipNo);
    url = this.appendParam(url, "vehRegNo", finalFilters.vehRegNo);
    url = this.appendParam(url, "srcCity", finalFilters.src.city);
    url = this.appendParam(url, "tripNo", finalFilters.tripNo);

    url = this.appendParam(url, "dstCity", finalFilters.dstCity);
    // url = this.appendParam(url, "paymentMode", finalFilters.paymentMode);
    if (status) {
      url = this.appendParam(url, "status", status);
    }

    url = this.appendParam(url, "vendorEntity", finalFilters.vendorEntity_id);
    // url = this.appendParam(url, 'clientSA', finalFilters.clientSA);
    url = this.appendParam(url, "clientEntity", finalFilters.clientEntity_id);

    return url;
  }

  async filterTrip() {
    if (!this.validateReport()) {
      return;
    }
    this.finalFilters = this.filter;
    const url = await this.filterTripParam(
      "/api/corp/trips/data?forInvoice=true&rows=" + this.rows,
      this.finalFilters
    );
    this.fetchTripData(url, 1);
    this.url_filter1 = url;
  }

  get loading() {
    return common.loading;
  }

  remove(list, index) {
    if (list && index != null && index != undefined) {
      list.splice(index, 1);
    }
  }

  async mounted() {
    await auth.doPostLogin();
    this.webcontent = auth.authContent;
  }
}
</script>
<style scoped>
.tariff-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  /* left: 10px; */
  right: 0px;
  font-size: 12px;
}
</style>
